﻿(function (factory) {
    factory(window);
}(function (wind) {
    wind.getAjaxData = function (url, method, isAsync, inData, callBack, errorCallback) {
        var responseData = "";
        if (method == null || method == '')
            method = 'GET';

        if (isAsync == null || isAsync == '')
            isAsync = false;

        cLog("Fetching Ajax data from " + url);
        $.support.cors = true;
        $.ajax({
            url: url,
            data: inData,
            async: isAsync,
            type: method,
            dataType: 'json',
            crossDomain: true,
            success: function (data) {
                if (data != null) {
                    responseData = data;
                    if (typeof (callBack) != "undefined" && typeof (callBack) == 'function')
                        callBack(responseData);
                } else {
                    responseData = data;
                    cLog('No data from ' + url);
                }
            },
            error: function (xhr, textStatus) {
                cLog('Error while executing request: \n' + textStatus + '\n' + xhr.statusText);
                if (typeof errorCallback == 'function') errorCallback(xhr, textStatus);
            }
        });
        return responseData;
    };

    wind.cLog = function (msg) {
        if (wind.console) {
            if (process.env.NODE_ENV != 'production') {
                console.log(msg);
            }
        }
    };

    wind.IsMobileDevice = function () {
        return navigator.userAgent.match(/Android/i)
            || navigator.userAgent.match(/webOS/i)
            || navigator.userAgent.match(/iPhone/i)
            || navigator.userAgent.match(/iPad/i)
            || navigator.userAgent.match(/iPod/i)
            || navigator.userAgent.match(/BlackBerry/i)
            || navigator.userAgent.match(/Windows Phone/i)
    }
}));